<template>
  <div style="margin: 0px 30px" class="report-15 report-fs" dir="rtl">
    <div style="margin-top: 200px" v-if="pathLogo == m"></div>

    <div class="mlogo">
      <img class="wlogo" :src="pathLogo" />
    </div>

    <h3 style="margin-bottom: 15px" class="text-center fs-head-co">
      {{ fullName }}
    </h3>
    <h3 style="margin-top: 0px" class="text-center fs-head-co">
      {{ shortName }}
    </h3>
    <h3
      style="font-weight: bold; padding-bottom: 40px"
      class="text-center fs-head"
    >
      كشف برصيد الإجازة السنوية
    </h3>

    <div class="md-layout-item md-size-100 mt-25">
      <h4 style="font-weight: bold" class="text-center">
        تقرير بأرصدة الإجازات حتى تاريخ
        <span style="margin: 5px"> {{ monthDate }} </span> للموظفين أصحاب
        الأرصدة الأكثر من <span style="margin: 5px"> {{ Days }} </span> يوما
      </h4>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card style="box-shadow: none">
          <div style="margin-top: 10px; margin-bottom: 35px" class="marginTop">
            <md-card-content>
              <md-table class="paginated-table table-striped table-hover mt-25">
                <md-table-row>
                  <md-table-cell>ر.م</md-table-cell>

                  <md-table-cell>اسم الموظف</md-table-cell>

                  <md-table-cell>الرقم الوظيفي</md-table-cell>

                  <md-table-cell>الادارة</md-table-cell>

                  <md-table-cell>رصيد الإجازات</md-table-cell>
                </md-table-row>
                <md-table-row v-for="(item, i) in allData" :key="i">
                  <md-table-cell md-label="الصنف">{{ i + 1 }}</md-table-cell>

                  <md-table-cell md-label="الصنف">{{
                    item.employeeName
                  }}</md-table-cell>

                  <md-table-cell md-label="الصنف">{{
                    item.jobNumber
                  }}</md-table-cell>

                  <md-table-cell md-label="الصنف">{{
                    item.departmentName
                  }}</md-table-cell>

                  <md-table-cell md-label="الصنف">{{
                    item.balanceDays
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </div>
          <section class="body">
            <div style="margin-top: 50px; width: 50%" class="first-section">
              <div class="right">
                <div class="t-body">
                  <p style="width: 100%">
                    عدد الموظفين أصحاب الأرصدة فوق 180 يوم
                  </p>
                  <p>{{ allData.length ? allData[0].countEmployee : "" }}</p>
                </div>
              </div>
            </div>
          </section>
        </md-card>

        <div class="md-layout mt-25 text-center last-footer">
          <div class="md-layout-item md-size-50">
            <p style="font-weight: bold; margin-bottom: 50px">
              إعداد قسم شؤون الموظفين
            </p>
            <p>--------------------------</p>
          </div>

          <div class="md-layout-item md-size-50">
            <p style="font-weight: bold; margin-bottom: 50px">
              اعتماد مدير إدارة الشؤون الإدارية
            </p>
            <p>--------------------------</p>
          </div>
        </div>
      </div>
    </div>

    <!-- <section class="body">
      <div style="margin-top: 50px" class="first-section">
        <div class="right">
          <div class="t-body">
            <p class="id">ر.ت</p>
            <p>اسم الموظف</p>
            <p>رقم الملف الشخص</p>
            <p class="line">الادارة</p>
            <p>رصيد الإجازات</p>
          </div>

          <div v-for="(item, i) in allData" :key="i" class="t-body">
            <p class="id">{{ i + 1 }}</p>
            <p>{{ item.employeeName }}</p>
            <p>{{ item.profileNumber }}</p>
            <p class="line">{{ item.departmentName }}</p>
            <p>{{ item.balanceDays }}</p>
          </div>
        </div>
      </div>

      <div style="margin-top: 50px; width: 50%" class="first-section">
        <div class="right">
          <div class="t-body">
            <p style="width: 100%">عدد الموظفين أصحاب الأرصدة فوق 180 يوم</p>
            <p>{{ allData.length ? allData[0].countEmployee : "" }}</p>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import env from "../../../env";

export default {
  props: ["allData", "fullName", "shortName", "Days", "monthDate", "pathLogo"],
  data() {
    return {
      m: env.mTop(),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/vacations_balance";

.report-fs {
  * {
    font-size: 22px !important;
    font-family: "Cairo", sans-serif !important;
  }

  .fs-head-co {
    font-size: 29px !important;
    font-weight: bold;
  }

  .fs-head {
    font-size: 27px !important;
  }
}
</style>
